import React from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";

const PaymentSuccess = ({ show, handleClose }) => {
  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="text-center subscription_modal">
          <div class="thank-you-pop">
            <img
              src="http://goactionstations.co.uk/wp-content/uploads/2017/03/Green-Round-Tick.png"
              alt="success img"
            />
            <h1>Payment Successful !</h1>
            <p>
              Your Payment for Demo Session is successful.Now you can Book a
              demo session.
            </p>
            <Link to="/bookasession">Book a session</Link>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PaymentSuccess;
